import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// auth
import { AuthGuard, RoleBasedGuard } from 'src/auth/guard';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';

// ----------------------------------------------------------------------
const IndexPage = lazy(() => import('src/pages/app-worker'));

// WORKER FETCH-LIST
const WorkerFetchListPage = lazy(() => import('src/pages/dashboard/fetchlistworker/list'));
const WorkerFetchListCreatePage = lazy(() => import('src/pages/dashboard/fetchlistworker/new'));
const WorkerFetchListEditPage = lazy(() => import('src/pages/dashboard/fetchlistworker/edit'));
const WorkerFetchListScanPage = lazy(() => import('src/pages/dashboard/fetchlistworker/scan'));

// ----------------------------------------------------------------------

export const userdashboardRoutes = [
    {
        path: 'worker-dashboard',
        element: (
            <AuthGuard>
                <RoleBasedGuard hasContent roles={['Admin', 'Worker']} sx={{ py: 10 }}>
                    <DashboardLayout>
                        <Suspense fallback={<LoadingScreen />}>
                            <Outlet />
                        </Suspense>
                    </DashboardLayout>
                </RoleBasedGuard>
            </AuthGuard>
        ),
        children: [
            { element: <IndexPage />, index: true },
            {
                path: 'workerfetchlist',
                children: [
                    { element: <WorkerFetchListPage />, index: true },
                    { path: 'list', element: <WorkerFetchListPage /> },
                    { path: 'new', element: <WorkerFetchListCreatePage /> },
                    { path: ':id/edit', element: <WorkerFetchListEditPage /> },
                    { path: ':id/scan', element: <WorkerFetchListScanPage /> },
                ],
            },
        ],
    },
];